import { render, staticRenderFns } from "./TakeAssessmentModal.vue?vue&type=template&id=6f3e76ff&scoped=true&"
import script from "./TakeAssessmentModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TakeAssessmentModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TakeAssessmentModal.vue?vue&type=style&index=0&id=6f3e76ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e76ff",
  null
  
)

export default component.exports